'use client';

import { type ReactNode, createContext, useContext, useState, SetStateAction, Dispatch } from 'react';

export type GeneralStoreApi = {
    vehicleType: number;
    setVehicleType: Dispatch<SetStateAction<number>>;
};

export const GeneralStoreContext = createContext<GeneralStoreApi | undefined>(undefined);

export interface GeneralStoreProviderProps {
    children: ReactNode;
    vehicleType: number;
}

export const GeneralStoreProvider = ({ children, ...props }: GeneralStoreProviderProps) => {
    const [vehicleType, setVehicleType] = useState(props.vehicleType);
    return (
        <GeneralStoreContext.Provider value={{ vehicleType, setVehicleType }}>{children}</GeneralStoreContext.Provider>
    );
};

export const useGeneralStore = (): GeneralStoreApi => {
    const generalStoreContext = useContext(GeneralStoreContext);

    if (!generalStoreContext) {
        throw new Error(`useFilterStore must be used within GeneralStoreProvider`);
    }

    return generalStoreContext;
};
